<template lang="html">
  <div>
    <header-component />
    <v-container fluid>
      <v-row align="center" justify="center" class="text-center grey--text">
        <v-col>
          <div class="display-3 ma-5 grey--text">Oops !</div>
          <div>Something seems to be broken or we can’t find what you're looking for.</div>
          <div class="ma-5">
            <v-icon size="64" color="yellow lighten-2">mdi-pac-man</v-icon>
            <v-icon size="64" color="yellow lighten-2">mdi-circle-small</v-icon>
            <v-icon size="64" color="yellow lighten-2">mdi-circle-small</v-icon>
            <v-icon size="64" color="grey lighten-2">mdi-file-alert-outline</v-icon>
            <v-icon size="64" color="yellow lighten-2">mdi-circle-small</v-icon>
            <v-icon size="64" color="yellow lighten-2">mdi-circle-small</v-icon>
            <v-icon size="64" color="red lighten-3">mdi-ghost</v-icon>
          </div>
          <div class="ma-5">
            <span>Go back to your</span>
            <v-btn text small color="blue" class="font-weight-bold" @click="goBackToPreviousPage()">previous page</v-btn>
            <span>or to the</span>
            <v-btn text small color="blue" class="font-weight-bold" @click="goBackToHomePage()">homepage</v-btn>
            <span>or</span>
            <v-btn text small color="blue" class="font-weight-bold" @click="contactUs()">contact us</v-btn>
            <span>for support.</span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent"

export default {
  components: {
    HeaderComponent,
  },
  methods: {
    goBackToPreviousPage() {
    },
    goBackToHomePage() {
      this.$router.push({ name: 'home', params: {} })
    },
    contactUs() {
    }
  }
}
</script>
